import { Button, withStyles } from '@material-ui/core';
import React from 'react';

import { smallRadius } from '~/src/dash/utils/material-dashboard-react';

interface IProps {
  onClick: () => void;
  buttonText?: string;

  // is the button position fixed on the bottom right?
  isFixedButton?: boolean; // default = true
}

function getPositionStyle(isFixed: boolean | undefined): React.CSSProperties {
  if (isFixed || isFixed === undefined) {
    return {
      top: 'auto',
      right: 20,
      bottom: 20,
      left: 'auto',
      position: 'fixed',
    };
  }
  return {};
}

// Button which show the `Open Live Logs`
export const LiveLogsButtonV2 = withStyles({
  root: {
    borderRadius: smallRadius,
  },
})(function (props: IProps) {
  return (
    <Button
      style={{
        margin: 0,
        ...getPositionStyle(props.isFixedButton),
        width: 'auto',
      }}
      color='primary'
      onClick={() => props.onClick()}
    >
      {props.buttonText ? props.buttonText : 'Open Network logs'}
    </Button>
  );
});
